import * as React from 'react'
import { usePlantSessionPaint, type PlantEquipment } from '@axilon-apps/domains-ontology-ui-state'
import { equipmentIconFor } from './equipment-icon'
import { PlantHref } from './PlantHref'
import { SessionMarkAffordances, sessionMarkClass } from './session-mark-ui'

export function EquipmentTile({ equipment }: { equipment: PlantEquipment }): React.ReactElement {
  const Icon = equipmentIconFor(equipment.equipment_type)
  const { markFor } = usePlantSessionPaint()
  const mark = markFor(equipment.id)
  return (
    <PlantHref
      id={equipment.id}
      label="Equipment"
      node={equipment}
      className={sessionMarkClass(
        'flex min-w-0 items-center gap-2.5 rounded-lg border bg-card p-2.5 text-card-foreground no-underline shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground',
        mark
      )}
    >
      <span className="grid size-8 shrink-0 place-items-center rounded-md bg-bg-sunk text-ink-3">
        <Icon size={16} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex min-w-0 items-center gap-1.5">
          <span className="block min-w-0 flex-1 truncate text-13 font-semibold text-ink">
            {equipment.name}
          </span>
          <SessionMarkAffordances mark={mark} />
        </span>
        {(equipment.equipment_type || equipment.vendor) && (
          <span className="block truncate font-mono text-11 text-ink-3">
            {equipment.equipment_type ?? '—'}
            {equipment.vendor ? ` · ${equipment.vendor}` : ''}
          </span>
        )}
      </span>
    </PlantHref>
  )
}
